var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { parseAccessToken } from 'lib-shared-auth';
import { elevioActions } from 'components/conversation/components/integrations/elevio/src/elevio.actions';
import { fetchElevioAuthToken } from './elevio';
import { elevioGraphqlRequestBaseQuery } from './elevioGraphqlRequestBaseQuery';
/**
 * A wrapper around graphqlRequestBaseQuery to allow headers to be set, as well
 * as handling errors or 404's when a company does not have an Elevio
 * workspace.
 */
export function elevioBaseQuery(client) {
    return (args, api, extraOptions) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        const { store } = yield import('store');
        // const existingLocalStorageToken =
        //   await elevioLocalStorageAuth.getElevioAuthToken();
        const existingReduxStoreToken = store.getState().elevio.suggestions.token;
        const authState = store.getState().elevio.suggestions.authState;
        if (!existingReduxStoreToken || authState === 'uninitialized') {
            store.dispatch(elevioActions.suggestions.fetchTokenStart());
            try {
                const result = yield fetchElevioAuthToken();
                const parsedToken = parseAccessToken(result.elevioToken);
                const companyUid = parsedToken.sub;
                const userId = parsedToken.userId;
                const userEmail = parsedToken.userName;
                store.dispatch(elevioActions.suggestions.fetchTokenSuccess({
                    elevioAuthStatus: 'success',
                    token: result.elevioToken,
                    companyUid,
                    userId,
                    userEmail,
                }));
            }
            catch (e) {
                store.dispatch(elevioActions.suggestions.fetchTokenError());
                const isError = axios.isAxiosError(e);
                if (isError) {
                    const axiosError = e;
                    return {
                        error: {
                            message: axiosError.message,
                            status: (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status,
                        },
                    };
                }
                return {
                    error: e,
                };
            }
        }
        // Set auth header
        const token = store.getState().elevio.suggestions.token;
        const bearer = `Bearer ${token}`;
        client.setHeader('authorization', bearer);
        // Set company-uid header
        const companyUid = store.getState().elevio.suggestions.companyUid;
        client.setHeader('company-uid', companyUid);
        try {
            const result = yield elevioGraphqlRequestBaseQuery({ client })(args, api, extraOptions);
            if (((_b = result.error) === null || _b === void 0 ? void 0 : _b.code) === 'UpgradeRequired') {
                store.dispatch(elevioActions.suggestions.subscriptionStatusError({
                    errorMessage: (_c = result.error) === null || _c === void 0 ? void 0 : _c.message,
                }));
            }
            else {
                store.dispatch(elevioActions.suggestions.subscriptionStatusSuccess());
            }
            /**
             * Sometimes graphql errors will still be returned as a 200 response, so
             * we need to check for error messages here and return an error if one is
             * found.
             */
            if ((_d = result.error) === null || _d === void 0 ? void 0 : _d.message) {
                return {
                    error: {
                        message: (_e = result.error) === null || _e === void 0 ? void 0 : _e.message,
                        code: (_f = result.error) === null || _f === void 0 ? void 0 : _f.code,
                    },
                };
            }
            return result;
        }
        catch (error) {
            return { error };
        }
    });
}
